// logger/clientLogger.js
export async function clientLog(level, message, meta = {}) {
  try {
    await fetch("/api/loggerAPI", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ level, message, meta }),
    });
  } catch (err) {
    console.error("Failed to send client log:", err);
  }
}
